import {
	Component,
	Injector,
} from '@angular/core';

import {
	trigger,
	transition,
} from '@angular/animations';

import { CommonBaseComponent } from '../../../Common/components/base.component';

@Component({
	templateUrl: './authentication.meetings.component.pug',
	selector: 'authentication-meetings-app',
	animations: [
		trigger('parentAnimation', [
			transition(':enter', []),
		]),
	],
})
export class AuthenticationMeetingsComponent extends CommonBaseComponent {
	constructor (
		protected injector: Injector,
	) {
		super(injector);
	}
}
